module.exports = {"id":"201438","name":"Hannes Van Der Bruggen","rating":"72","photo":"./data/images/photos/2/201438.png","club":{"name":"KV Courtrai","logo":"./data/images/clubs/KVCourtrai.png"},"positions":["MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HannesVanDerBruggen0.json
// module id = 1689
// module chunks = 0